import React from "react";
import { Link } from "react-router-dom";

const handleLogin = () => {
    window.open("/auth0/login", "_self");
};

const LoginSignup = () => (
    <section className="contact-wrapper">
        <div className="container">
            <div className="row">
                <div className="col-md-12">
                    <h3 className="title">Please login or signup</h3>
                    <p>
                        You must be a Freebird member to send messages or
                        request bookings. Please{" "}
                        <Link onClick={() => handleLogin()}>Login</Link> or{" "}
                        <Link to="/signup">Join Club</Link>.
                    </p>
                </div>
            </div>
        </div>
    </section>
);

export default LoginSignup;
